let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7n0BP")).then(() => parcelRequire('8iZ79'));